import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { JOIN_TYPE } from '@/common/constants/ConstCode';
const { GENERAL } = JOIN_TYPE;

export const state = {
  accessToken: null,
  refreshToken: null,
  ttl: null,
  role: null,
  familyList: [],
  terms: '', // 약관 동의 페이지에 어떤 내용을 보여줄지 결정하는 부분
  code: '', // 국가코드
  phone: '', // 휴대폰 인증 메시지를 받을 휴대폰 번호
  authCode: '', // 휴대폰인증API에서 받아온 코드를 저장,
  firstLoginChk: false,
  purchaseCallBack: '', // 인앱 결제가 종료된 후 실행할 콜백
  purchase: {
    productNo: '', // 구매할 상품의 시퀀스
    category: '', // 아이템의 카테고리
    productCode: '', // itemType
    price: '', // 가격,
    useTargetNo: '', // 배경화면 / 이모티콘 구매시 타겟 No
    name: '' // 상품명
  },
  church: {
    churchNo: null,
    churchName: '',
    address: '',
    roadAddress: '',
    isContracted: false
  },
  userData: {
    authNo: null,
    userId: null,
    joinType: GENERAL.value,
    role: null,
    status: null,
    userNo: null,
    churchNo: '',
    churchName: '',
    name: null,
    phone: null,
    isAgreeMarketing: '',
    isAgreeBusinessMarketingPush: '',
    isAgreePush: '',
    isRead: '',
    canSuperChat: '',
    familyCode: '', // 가족선택시 저장
    familyName: '', // 가족의 명칭,
    representFamilyCode: '', // 내가 가족대표로있는 가족의 코드번호
    representFamilyName: '', // 내가 가족대표로있는 가족의 이름
    isRepresent: false, // 대표를 맡고 있는 가족이 있는지 여부 체크용도 ( 모든 가족 통틀어서 )
    currentRepresent: false, // 현재 접속한 가족이 내가 대표인 가족인지 체크
    isNotFamily: false, // 현재 소속되어있는 가족이 없는 경우 true 있을경우 false,
    // UserBenefitInfo
    userGrade: '',
    churchStatus: '',
    hasWellPassword: false,
    passExpireDate: '',
    benefitExpireDate: '',
    point: 0
  },
  // 회원가입 단계에서 사용되는 정보들을 저장하는 객체
  signUp: {
    // 회원가입 API에 필요한 데이터들  ( 이 외에는 Front단계에서 필요로 인해 사용하는 데이터들 )
    isSns: false,
    isPremium: false,
    couponNumber: null,
    form: {
      name: '',
      userId: '',
      password: '',
      phone: '',
      code: '+82', // 기본값은 한국
      birthDate: '',
      isAgreePush: '',
      isAgreeMarketing: false,
      familyCode: '',
      familyName: '',
      churchNo: '',
      userNo: '',
      joinMenu: '',
      joinType: GENERAL.value,
      isFamilyRepresent: '',
      deviceInfo: '',
      churchName: '',
      address: '',
      roadAddress: '',
      latitude: '',
      longitude: ''
      // ... 교회 회원가입 시 필요한 데이터들 추가됨
    },
    phoneCode: '',
    phoneState: '',
    isAgreeService: false,
    isAgreePrivacy: false,
    duplicated: false
  },
  find: {
    form: {
      phone: '',
      userId: '',
      password: '',
      regData: ''
    }
  },
  findAccounts: [],
  deviceInfo: {
    deviceNo: null,
    userNo: null,
    deviceType: 'WEB',
    deviceId: 'WEB',
    pushToken: null,
    appVersion: '1.0.0',
    os: 'WEB',
    syncDate: null
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
